<script lang="ts" setup>
import { TRACKING_EVENTS } from "@constant"
import { TrackingPlugin } from "@plugins/tracking.plugin"
import { useFormStore } from "@stores/form.store"
import { inject, onActivated, onDeactivated, ref } from "vue"

const { snapshot, send } = useFormStore()

const { $track } = inject<TrackingPlugin>("tracking")!

const timeCompletion = ref(new Date().getTime())

onActivated(async () => {
    timeCompletion.value = new Date().getTime()
    $track(TRACKING_EVENTS.STEP_ENTERED, {
        step: snapshot.value.context.step + 1,
        formId: "",
    })
})

onDeactivated(() => {
    $track(TRACKING_EVENTS.STEP_COMPLETED, {
        step: snapshot.value.context.step + 1,
        formId: "",
        timeCompletion: (
            (new Date().getTime() - timeCompletion.value) /
            1000
        ).toFixed(1),
    })
})
</script>

<template>
    <FormCard class="form-invalid" :footer-btn="false">
        <template #header>
            <div class="form-invalid__header">
                <h1>
                    Logement non éligible
                    <span class="pi pi-exclamation-circle"></span>
                </h1>
            </div>
        </template>
        <div class="form-invalid__content">
            <h4>Merci pour votre intérêt dans le programme Watt Watchers !</h4>
            <p>
                Seuls les logements disposant d'un
                <span class="underline">chauffage</span> et d'<span
                    class="underline"
                    >une eau chaude individuels</span
                >
                peuvent participer à l'étude.Nous ne pouvons donc pas donner
                suite à votre inscription.Très bonne journée à vous, et bravo
                encore pour vos travaux de rénovation !"
            </p>
        </div>
        <BaseButton
            severity="secondary"
            class="button-link"
            label="Retour au formulaire"
            @click="
                () => {
                    $track(TRACKING_EVENTS.CLICK_BUTTON, {
                        buttonId: 'back-to-form',
                        buttonName: 'Retour au formulaire',
                    })
                    send({ type: 'BACK' })
                }
            "
        >
        </BaseButton>
        <p class="form-invalid__link">
            Nous restons à votre disposition pour toute information
            complémentaire sur
            <BaseButton
                variant="link"
                as="a"
                size="small"
                class="button-link"
                href="mailto:contact@wattwatchers"
                label="contact@wattwatchers.fr"
            />
            et le
            <BaseButton
                variant="link"
                as="a"
                size="small"
                class="button-link"
                href="tel:+33162345467"
                label="+33 01 62 34 54 67"
            />
        </p>
    </FormCard>
</template>

<style scoped>
.form-invalid {
    --gap-form: 3.5rem;
    --padding-form: 3.5rem;
    &:deep(.p-card-content) {
        display: flex;
        flex-direction: column;
        gap: var(--gap-form);
        padding-top: var(--padding-form);
        max-width: 48rem;
        margin: 0 auto;

        @media (--small-viewport) {
            --gap-form: 2.5rem;
            --padding-form: 2.5rem;
        }
    }

    .form-invalid__header {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        h1 {
            color: #be4f4f;
            text-align: center;
            font-size: 2rem;
            font-weight: 400;

            span {
                font-size: 1.4rem;
            }
        }
    }

    .form-invalid__content {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        h4 {
            color: var(--p-primary-800);
            text-align: center;
            font-size: 1.25rem;
            font-weight: 700;
        }
        p {
            text-align: center;
            font-weight: 400;
        }
    }

    p {
        color: var(--p-primary-800);
        text-align: center;
    }

    .form-invalid__link {
        font-size: 0.875rem;
        font-weight: 500;

        max-width: 40rem;

        .p-button-link {
            --p-button-sm-padding-y: 0;
            --p-button-sm-padding-x: 0.2rem;
            --p-button-sm-font-size: 0.875rem;
            --p-button-link-color: var(--p-primary-400) !important;
        }
    }
}
</style>
